module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-D02-clean-7d8dc18af984f04f784466329be15568.png";